import React from "react"
import { graphql } from "gatsby"
import "./_style.scss"

import Layout from "§/src/components/layout"
import Breadcrumb from "§/src/components/atoms/breadcrumb/breadcrumb"
import SchemaBreadcrumb from "§/src/components/schema/s-breadcrumb"

import Error from "§/src/components/error"
import SEO from "§/src/components/seo"

// Functions
import { isEmpty } from "lodash"

// Switch Language
import { getFormattedLanguage } from "§/src/utils/functions"

// Components
import TextModule from "§/src/components/atoms/content/text-module"
import TileContentDownloads from "§/src/components/atoms/content/tile-content-downloads"

const formId = process.env.GATSBY_SITE_LANG === 'it_IT' ? 12 : 11
const privacyLink = process.env.GATSBY_SITE_LANG === 'it_IT' ? "/informativa-privacy-vulnerability-disclosure-it.pdf" : "/informativa-privacy-vulnerability-disclosure-en.pdf"

import ContactModalVulnerability from "§/src/components/contact-modal-vulnerability"

export function Head(props) {
  const seo = props?.pageContext?.seo || {}

  return (
    <React.Fragment>
      <html lang={getFormattedLanguage(process.env.GATSBY_SITE_LANG)}></html>
      <body className="temp-vulnerability-disclosure"></body>
      <SEO seo={seo} translations={props?.data?.lang?.translations}/>
      <SchemaBreadcrumb breadcrumbs={seo?.breadcrumbs} />
    </React.Fragment>
  )
}

const TemplateVulnerabilityDisclosure = props => {
  const page = props?.pageContext?.acfPages_vulnerability_disclosure;

  const downloadFile = async (fileUrl, fileName) => {
    // Verifica che siamo in un ambiente browser
    if (fileUrl && typeof document !== 'undefined') {
      try {
        let alink = document.createElement("a")
        alink.href = fileUrl
        alink.download = fileName || 'download'
        alink.target = "_blank"
        alink.click()

        // Pulizia per evitare memory leaks
        setTimeout(() => {
          alink = null;
        }, 100);
      } catch (error) {
        console.error('Download failed:', error);
      }
    }
  }

  return (
    <Layout lang={props?.data?.lang?.translations}>
      <Breadcrumb wpseo={props?.pageContext?.seo?.breadcrumbs} />

      {!isEmpty(props?.pageContext) ? (

        <React.Fragment>

          <div className="d-flex flex-column gap-5">
            <div className="d-flex flex-column gap-1 pt-3">
              <h1 className="title mb-3">{props?.pageContext?.title}</h1>
            </div>
          </div>
          
          {page?.textModules?.map((item, index) => {
            return (
              <React.Fragment key={"text-module-" + index}>
                <TextModule
                  from="news-template"
                  pretitle={item?.preTitle}
                  title={item?.title}
                  content={item?.content}
                  downloadstitle={item?.downloads?.title}
                  downloadsfiles={item?.downloads?.downloadFiles}
                  reports={item?.reports}
                  className={"bg-full py-4 py-md-5 g-100"}
                  cta={item?.cta}
                />
                {item.downloadFiles &&
                  item.downloadFiles.map((file, fileId) => (
                    <div key={"download" + fileId} className={"col-12"}>
                      <TileContentDownloads
                        className={"normal col-md-12 col-lg-7 col-xl-5 offset-lg-5 offset-xl-4 mb-4"}
                        downloadsfiles={[file]}
                        ondownload={downloadFile}
                      />
                    </div>
                  ))}
              </React.Fragment>
            )
          })}

          <ContactModalVulnerability
            formId={formId}
            dedicatedPrivacyPolicyLink={privacyLink}
          />

        </React.Fragment>

      ) : (
        <Error message="Something Went Wrong" />
      )}
    </Layout>
  )
}

export default TemplateVulnerabilityDisclosure

export const pageQuery = graphql`
  query GET_TRANSLATIONS($eq: String!) {
    lang: wpPage(slug: { eq: $eq }) {
      translations {
        postUrl
        siteId
      }
    }
  }
`
